const getLocaleCookie = (rootState) => rootState.config.common.authtkt.current_language_cookie;

export default getLocaleCookie;
